<template>
  <div id="stepperWrapper" v-if="itemList.length" data-vc-full-width="true" data-vc-full-width-init="true" class="vc_row vc_row-outer vc_row-fluid" style="position: relative; box-sizing: border-box;">
    <div id="tm-column-5d8c5fc25d182" class="hoa-gradation wpb_column vc_column_container vc_col-sm-12">
      <div class="vc_column-inner ">
        <div class="wpb_wrapper">
          <v-layout wrap class="tm-gradation  tm-gradation--with_image tm-animation-queue" id="tm-gradation-5d8c5fc25d417" data-animation-delay="400">
            <v-flex xs12 md3 class="item animate" :key="i" v-for="(step, i) of itemList">
              <div class="image-wrap has-image">
                <div class="count">
                  <span class="number">{{ i + 1 }}</span>
                </div>
                <img width="100" :src="step.image" alt="Gradation Image">
              </div>
              <div class="content-wrap">
                <h5 class="title">{{ step.name }}</h5>
                <div class="text">{{ step.description }}</div>
              </div>
            </v-flex>
          </v-layout>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* global session */

// This is to show the stepwise instructions to the user
export default {
  name: 'app-stepper',
  components: {
  },
  props: {
    // List of items that describes each steps
    itemList: {
      type: Array,
      default: [],
      required: true
    }
  },
  data: () => ({

  }),
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  computed: {
  },
  watch: {
  },
  created () {
    // 
  }
};
</script>


<style scoped>

.tm-gradation {
  margin: 0 -15px;
  display: flex;
  position: relative;
}
.tm-gradation .count {
  font-size: 36px;
  font-weight: 700;
  color: #ddd;
  margin-bottom: 20px;
  line-height: 1.22;
}
.tm-gradation .count-wrap {
  position: relative;
  height: 28px;
  margin-bottom: 27px;
}
.tm-gradation .dot {
  width: 28px;
  height: 28px;
  border-radius: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
}
.tm-gradation .dot:before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 18px;
  height: 18px;
  border-radius: 50%;
}
.tm-gradation .dot:after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 10px;
  height: 10px;
  border-radius: 50%;
}
.tm-gradation .line {
  position: absolute;
  top: 14px;
  left: 0;
  border-top: 1px dashed #d4d2d2;
  width: calc(100% + 30px);
  height: 1px;
  margin-top: -1px;
}
.tm-gradation .item {
  width: calc(100% / 3);
  padding: 0 15px;
  position: relative;
  opacity: 1;
}
.tm-gradation .item:first-child .line:before {
  display: none;
}
.tm-gradation .item:last-child .line:after {
  display: none;
}
.tm-gradation .title {
  font-size: 15px !important;
  margin-bottom: 10px;
}
.tm-gradation--basic {
  overflow: hidden;
}
.tm-gradation--basic .dot {
  width: 28px;
  height: 28px;
  border-radius: 100%;
  position: absolute;
  top: 50%;
  left: 0;
  transform: translate(0, -50%);
}
.tm-gradation--no_number {
  padding-top: 28px;
}
.tm-gradation--no_number:before {
  content: "";
  width: calc(100% - 30px);
  height: 1px;
  border-top: 1px dashed #d4d2d2;
  position: absolute;
  top: 14px;
  left: 15px;
}
.tm-gradation--no_number .dot {
  top: -14px;
}
.tm-gradation--no_number .count-wrap {
  margin-bottom: 20px;
}
.tm-gradation--no_number .content-wrap {
  position: relative;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.06);
  padding: 50px 25px;
  text-align: center;
}
.tm-gradation--no_number .content-wrap:after {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  top: 0;
  left: calc(50% + 21px);
  box-sizing: border-box;
  border: 15px solid;
  border-color: transparent transparent #fff #fff;
  transform-origin: 0 0;
  transform: rotate(-225deg);
  -webkit-filter: drop-shadow(-3px 3px 10px rgba(0, 0, 0, 0.05));
  filter: drop-shadow(-3px 3px 10px rgba(0, 0, 0, 0.05));
}
.tm-gradation--with_image {
  text-align: center;
}
.tm-gradation--with_image .item {
  width: calc(100% / 3);
}
.tm-gradation--with_image img {
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.11);
}
.tm-gradation--with_image .count {
  margin: 0;
  line-height: 1;
}
.tm-gradation--with_image .count span {
  display: inline-block;
  position: relative;
  color: #fff;
  background-color: #4c9e8c;
  width: 30px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  border-radius: 50%;
  font-size: 18px;
  font-weight: 700;
}
.tm-gradation--with_image .count span:before, .tm-gradation--with_image .count span:after {
  display: inline-block;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  content: "";
  border-radius: 50%;
  background-color: #4c9e8c;
  z-index: -1;
}
.tm-gradation--with_image .count span:before {
  width: 40px;
  height: 40px;
  opacity: 0.2;
}
.tm-gradation--with_image .count span:after {
  width: 50px;
  height: 50px;
  opacity: 0.09;
}
.tm-gradation--with_image .image-wrap {
  padding-top: 12px;
  margin-bottom: 10px;
}
.tm-gradation--with_image .image-wrap img {
  border-radius: 50%;
}
.tm-gradation--with_image .image-wrap.has-image {
  padding-top: 0;
  position: relative;
  display: inline-block;
}
.tm-gradation--with_image .image-wrap.has-image .count {
  position: absolute;
  top: -10px;
  left: 0px;
  z-index: 2;
}
.tm-gradation--with_image .item:hover .count span:before, .tm-gradation--with_image .item:hover .count span:after {
  -webkit-animation: circle-2 1.05s infinite;
  -moz-animation: circle-2 1.05s infinite;
  -ms-animation: circle-2 1.05s infinite;
  -o-animation: circle-2 1.05s infinite;
  animation: circle-2 1.05s infinite;
}
@-webkit-keyframes circle-2 {
  100% {
    width: 200%;
    height: 200%;
    opacity: 0;
  }
}
@keyframes circle-2 {
  100% {
    width: 200%;
    height: 200%;
    opacity: 0;
  }
}
@media (min-width: 960px) {
    #stepperWrapper {
    background-image: url(/static/stepper/stepper_bg.png);
    background-repeat: no-repeat;
    background-size: contain;
    background-position: 0 -13px;
  }
}
.item.animate {
  margin-bottom: 15px;
}

</style>



// WEBPACK FOOTER //
// src/components/appStepper.vue